<div class="branding-form-container">
  <form nz-form [formGroup]="form" [nzLayout]="'vertical'">

    <div class="form-section">
      <!-- <div class="section-header">
        <h3 class="section-title">Branding Requirements</h3>
      </div> -->

      <div class="two-col-grid">

        <div class="stage-inline-row">
          <nz-form-item class="stage-inline-item stage-toggle">
            <nz-form-label nzRequired>Stage</nz-form-label>
            <nz-form-control>
              <nz-radio-group formControlName="is_stage_required">
                <label nz-radio [nzValue]="true">Yes</label>
                <label nz-radio [nzValue]="false">No</label>
              </nz-radio-group>
            </nz-form-control>
          </nz-form-item>

          <nz-form-item class="stage-inline-item stage-size" *ngIf="form.get('is_stage_required')?.value">
            <nz-form-label nzRequired>Stage Size</nz-form-label>
            <nz-form-control>
              <nz-radio-group formControlName="stage_size_option" nzButtonStyle="solid">
                <label nz-radio-button nzValue="small">Small (8x8)</label>
                <label nz-radio-button nzValue="medium">Medium (12x8)</label>
                <label nz-radio-button nzValue="large">Large (16x8)</label>
                <label nz-radio-button nzValue="custom">Custom</label>
              </nz-radio-group>
            </nz-form-control>
          </nz-form-item>

          <nz-form-item class="stage-inline-item stage-dimension"
            *ngIf="form.get('is_stage_required')?.value && form.get('stage_size_option')?.value === 'custom'">
            <nz-form-label nzRequired>Width</nz-form-label>
            <nz-form-control>
              <input nz-input type="number" min="1" formControlName="stage_dimension_x" placeholder="W" />
            </nz-form-control>
          </nz-form-item>

          <nz-form-item class="stage-inline-item stage-dimension"
            *ngIf="form.get('is_stage_required')?.value && form.get('stage_size_option')?.value === 'custom'">
            <nz-form-label nzRequired>Height</nz-form-label>
            <nz-form-control>
              <input nz-input type="number" min="1" formControlName="stage_dimension_y" placeholder="H" />
            </nz-form-control>
          </nz-form-item>
        </div>

        <nz-form-item>
          <nz-form-label >Stage & Stage Accessories</nz-form-label>
          <nz-form-control>
            <nz-select nzMode="multiple" nzShowSearch nzAllowClear formControlName="stage_accessories"
              nzPlaceHolder="Select Stage & Stage Accessories">
              <nz-option *ngFor="let v of stageAccessoriesResponseModel.value.results" [nzValue]="v.id"
                [nzLabel]="v.name">
              </nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label >Guest Management</nz-form-label>
          <nz-form-control>
            <nz-select nzMode="multiple" nzShowSearch nzAllowClear formControlName="guest_management"
              nzPlaceHolder="Select guest management">
              <nz-option *ngFor="let v of guestManagementResponseModel.value.results" [nzValue]="v.id" [nzLabel]="v.name">
              </nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label >Signage & Branding</nz-form-label>
          <nz-form-control>
            <nz-select nzMode="multiple" nzShowSearch nzAllowClear formControlName="signage_branding"
              nzPlaceHolder="Select signage & branding">
              <nz-option *ngFor="let v of signageBrandingResponseModel.value.results" [nzValue]="v.id" [nzLabel]="v.name">
              </nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label >Demo & Engagement</nz-form-label>
          <nz-form-control>
            <nz-select nzMode="multiple" nzShowSearch nzAllowClear formControlName="demo_engagement"
              nzPlaceHolder="Select demo & engagement">
              <nz-option *ngFor="let v of demoEngagementResponseModel.value.results" [nzValue]="v.id" [nzLabel]="v.name">
              </nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label >Media Advertising</nz-form-label>
          <nz-form-control>
            <nz-select nzMode="multiple" nzShowSearch nzAllowClear formControlName="media_advertising"
              nzPlaceHolder="Select media advertising">
              <nz-option *ngFor="let v of mediaAdvertisingResponseModel.value.results" [nzValue]="v.id"
                [nzLabel]="v.name">
              </nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label >Setup & Branding</nz-form-label>
          <nz-form-control>
            <nz-select nzMode="multiple" nzShowSearch nzAllowClear formControlName="setup_branding"
              nzPlaceHolder="Select setup & branding">
              <nz-option *ngFor="let v of setupBrandingResponseModel.value.results" [nzValue]="v.id" [nzLabel]="v.name">
              </nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-control>
            <button nz-button nzType="primary" (click)="onSave()" [disabled]="form.invalid">
              Submit
            </button>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

  </form>
</div>